import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

import { IonAlert, } from '@ionic/vue';
import { IAlertConfig } from '@/const/types/alert';
import { unref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicAlertsList',
  props: {
    alerts: null
  },
  setup(__props: any) {

const props = __props as {
  alerts: IAlertConfig[];
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.alerts, (alert) => {
    return (_openBlock(), _createBlock(_unref(IonAlert), {
      key: `alert-${alert.id}`,
      isOpen: unref(alert.isOpen),
      header: alert.header,
      buttons: alert.buttons,
      inputs: alert.inputs,
      onDidDismiss: ($event: any) => (alert.didDismiss())
    }, null, 8, ["isOpen", "header", "buttons", "inputs", "onDidDismiss"]))
  }), 128))
}
}

})